export default "__VITE_ASSET__a27bfa75__"